import React, { useEffect } from "react";
import { StyleSheet, Text } from "react-native";
import * as Sentry from "@sentry/react-native";
import { LinearGradient } from "expo-linear-gradient";
import { usePathname, useRouter } from "expo-router";

import ActionButton from "@/Components/Buttons/ActionButton";
import { themes } from "@/Components/Styling/themeConfigs";

export default function NotFound(): React.JSX.Element {
  const currentTheme = themes.morning;
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const error = new Error(
      `Unmatched Route: No screen found for path "${pathname}"`,
    );
    Sentry.addBreadcrumb({
      category: "navigation",
      message: `Navigated to unmatched route: ${pathname}`,
    });
    Sentry.captureException(error);
  }, []);

  const handleGoBack = (): void => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace("/");
    }
  };

  return (
    <LinearGradient
      colors={currentTheme.bg}
      style={styles.container}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
    >
      <Text style={styles.error}>🐼</Text>
      <Text style={styles.title}>Oops! Something went wrong.</Text>
      <Text style={styles.message}>We have notified our team.</Text>
      <ActionButton onPress={handleGoBack} label="Go Back" variant="filled" />
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
    backgroundColor: "#fff",
  },
  error: {
    fontSize: 150,
    fontWeight: "700",
    color: "#A757FF",
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: "600",
    color: "#000000",
    marginBottom: 12,
  },
  message: {
    fontSize: 16,
    color: "#555",
    textAlign: "center",
    marginBottom: 20,
  },
});
